const styles = (theme) => ({
	root: {
		cursor: "none !important",
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
		padding: "0 10rem",
		margin: "auto",
		maxWidth: "1700px",
		position: "relative",
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1410)]: {
			padding: "0 7rem",
		},
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1360)]: {
			padding: "0 5rem",
		},
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
			flexDirection: "column",
			padding: "0 1rem",
		},
	},
	img: {
		maxHeight: "600px",
		marginBottom: "-4px",
		transition: "all 0.3s",
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
		maxWidth: "100%",
		},
	},
	span: {
		cursor: "none !important",
		
		display: "flex",
		justifyContent: "center",
		alignItems: "flex-start",
		flexDirection: "column",
		width: "100%",
		marginLeft: "130px",
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1360)]: {
		marginLeft: "70px",
		},
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
		marginLeft: "0",
		},
	},
	h3: {
		fontFamily: "Montserrat",
		fontWeight: "700",
		letterSpacing: "0.01em",
		lineHeight: "75px",
		fontSize: "60px",
		color: "#000",
		margin: 0,
		textAlign: "left",
		width: "100%",
		marginBottom: "40px",
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
			marginBottom: "20px",
			marginTop: "45px",
		},
		[theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
			fontSize: "2rem",
			lineHeight: "38.5px",
		},
	},
	p: {
		cursor: "none !important",
		fontFamily: "Aktiv Grotesk",
		color: "#000",
		display: "table",
		fontSize: "1rem",
		margin: 0,
		fontWeight: 400,
		lineHeight: "22.5px",
		maxWidth: "60ch",
		letterSpacing: "0.01em",
		paddingBottom: "30px",
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
			paddingBottom: 0,
		},
	},
	secondRoot: {
		marginTop: "-1px",
		paddingBottom: "130px",
		display: "flex",
		justifyContent: "flex-start",
		paddingLeft: "10rem",
		alignItems: "center",
		transition: "all 0.3s",
		position: "relative",
		margin: "auto",
		maxWidth: "1700px",
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1410)]: {
			paddingLeft: "7rem",
		},
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1360)]: {
			padding: "0 5rem 130px 5rem",
			justifyContent: "flex-end",
		},
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
			padding: "0 1rem 80px 1rem",
			justifyContent: "center",
		},
	},
	secondImg: {
		marginBottom: "-4px",
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
			order: 1,
			maxHeight: "350px",
		},
		[theme.breakpoints.down(theme.breakpoints.values.xs + 550)]: {
			maxWidth: "100%",
		},
	}, 
	reveal: {
		marginTop: "-50px",
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1150)]: {
		order: 1,
		marginTop: "30px",
		marginBottom: "30px",
		},
	},
	secondReveal: {
		marginLeft: "570px", // check width of image on first root
		[theme.breakpoints.down(theme.breakpoints.values.xs + 1360)]: {
			marginLeft: "0",
		},
	},
});
export default styles;